import React from 'react';

const SvgAltSearch = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg aria-hidden="true" width={17} height={17} fill="none" {...props} viewBox="0 0 17 17">
      <path
        d="M11.3165 10.2506H10.7569L10.5586 10.0594C11.4086 9.06769 11.8478 7.71477 11.6069 6.27686C11.274 4.30769 9.63069 2.73519 7.64736 2.49436C4.65111 2.12602 2.12944 4.64769 2.49777 7.64394C2.73861 9.62727 4.31111 11.2706 6.28027 11.6035C7.71819 11.8444 9.07111 11.4052 10.0628 10.5552L10.254 10.7535V11.3131L13.2644 14.3235C13.5549 14.6139 14.0294 14.6139 14.3199 14.3235C14.6103 14.0331 14.6103 13.5585 14.3199 13.2681L11.3165 10.2506ZM7.06652 10.2506C5.30277 10.2506 3.87902 8.82686 3.87902 7.06311C3.87902 5.29936 5.30277 3.87561 7.06652 3.87561C8.83027 3.87561 10.254 5.29936 10.254 7.06311C10.254 8.82686 8.83027 10.2506 7.06652 10.2506Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgAltSearch;
